import { Stack } from '@mui/material';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { MobileTitle } from '../../../../components/style/TextStyle';
import { useAuthAxios } from '../../../../hooks/useAuthAxios';
import { useYupValidationResolver } from '../../../../hooks/useYupValidationResolver';
import { responsiveMargin } from '../../../../utils/enum';
import { CreateTypeForm } from '../Common/CreateCategoryForm';
import { typeDefaultValue, typeSchema } from '../Common/DefaultValuesAndSchema';
import AddMobileCategoryButton from './AddMobileCategoryButton';
import { GoBackIconButton } from './GoBackIconButton';

export default function TypeCategoryMobile() {
  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...typeSchema,
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...typeDefaultValue,
    },
    shouldUnregister: false,
  });

  const [postCategoryResult, postCategory] = useAuthAxios({
    method: 'POST',
    url: '/api/v1/category',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  const onSubmit = form.handleSubmit(function (values) {
    const data = new FormData();
    data.append('categoryId', values.categoryId);
    data.append('categoryType', values.categoryType);
    data.append('title', values.title);
    data.append('notes', values.notes);
    data.append('file', values.file);

    postCategory({ data });
  });

  return (
    <Stack mx={responsiveMargin} spacing={5} my={{ xs: 2, md: 10 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <GoBackIconButton form={form} />
        <MobileTitle>구분 추가</MobileTitle>
        <AddMobileCategoryButton
          title="구분 추가"
          onSubmit={onSubmit}
          postResult={postCategoryResult}
        />
      </Stack>
      <CreateTypeForm form={form} />
    </Stack>
  );
}
